<template>
  <div>
    <button class="btn btn-sm m-l-lg m-b-sm" type="button" @click="chartOpen()" >
      {{ isOpen ? 'Close' : 'Open' }}
    </button>
    <span class="m-l-lg lead"> {{ chartName }} </span>

    <transition name="expand">
      <div v-if="isOpen">
        <apexchart type=bar :height="this.height" :options="this.chartOptions" :series="this.series"/>
      </div>
    </transition>
  </div>

</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue'
import { startCase, toLower } from 'lodash'

Vue.component('apexchart', VueApexCharts)
export default {
  props: {
    showBrush: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    uniqueName: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 240
    },
    filterParams: {
      type: Object
    }
  },

  data () {
    return {
      autoScaleYaxis: false,
      isOpen: false,
      chartData: []
    }
  },
  methods: {
    chartOpen () {
      this.isOpen = !this.isOpen
      this.$http.get(`business_intelligence/${this.uniqueName}/data`, { params: this.filterParams }).then(response => {
        this.chartData = response.data[0]
      })
    }
  },
  computed: {
    chartName () {
      return startCase(toLower(this.name))
    },
    xaxisCategories () {
      return this.chartData ? this.chartData.xaxisCategories : []
    },

    series () {
      return this.chartData.categories ? Object.keys(this.chartData.categories).map((key, index) => {
        return {
          name: key,
          data: this.chartData.categories[key]
        }
      }) : []
    },

    chartOptions () {
      return {
        title: {
          text: '',
          align: 'left',
          offsetY: 20
        },
        dataLabels: {
          style: {
            colors: ['#000000']
          }
        },
        chart: {
          zoom: {
            enabled: true
          },
          id: this.name,
          toolbar: {
            autoSelected: 'pan',

            show: true
          },
          name: this.name,
          type: 'bar'
        },
        xaxis: {
          tickPlacement: 'on',
          categories: this.xaxisCategories
        },
        tooltip: {
          x: {
            formatter: (val) => {
              if (Array.isArray(val)) {
                return val.join(' ')
              }
              return val
            }
          }
        },
        reversed: true
      }
    }
  }
}
</script>
